// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-state-component {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  margin: 3rem 0; }\n  .empty-state-component .bars {\n    padding: 1rem;\n    background-color: #ffdad2;\n    border-radius: 50%;\n    margin-bottom: 1rem; }\n  .empty-state-component .message {\n    text-align: center; }\n", ""]);
// Exports
module.exports = exports;
